import React from 'react';
import { connect } from 'react-redux';
import { setLanguage, toggleLanguageMenu } from '../../redux/actions';
import generateFlag from './generateFlag';

const LanguageItem = props => {

    const setLanguageHandler = () => {
        //debugger;
        let lanObj = props.language;
        if(props.configuration.domesticPolicy && props.configuration.domesticLanguages[props.language.code+"-dom"]){
            //debugger;
            lanObj = props.configuration.domesticLanguages[props.language.code+"-dom"];
        }
        props.setLanguage(lanObj);
        props.toggleLanguageMenu(!props.isLanguageMenuOpen);
    }

    return (
    <li onClick={setLanguageHandler} ><div className={props.className}>{generateFlag(props.languageCode)}</div><div>{props.title}</div></li>
    );
};

const mapStatetoProps = state => {
    return {...state};
};

export default connect(mapStatetoProps,{setLanguage,toggleLanguageMenu})(LanguageItem);